import React from "react";
import ErrorPage from "./ErrorPage";

export default function Error401(props) {
  return <ErrorPage code={401} {...props} />;
}
